import el from "element-ui/src/locale/lang/el";
import { getComment } from '../../js/axios'

export default {
    name: 'recordOfOpening',
    data() {
        return {
            tableData: [
            ],
            totalPage:1,
            pageCount:1,
            tipStatus: "",
            tipText: "",
            alertShow: false,

            nameW:0,
            sexW:0,
            birthW:0,
            useridW:0,
            phoneW:0,
            openW:0,
            timeW:0,
        }
    },
    created() {
    },
    mounted() {
        this.getDate();
        this.resizeChange();
        window.onresize = () => {
            return (() => {
                this.resizeChange()
            })();
        };
    },
    methods: {

        resizeChange() {
            let tableWidth = document.getElementsByClassName('el-table__body-wrapper')[0].offsetWidth;
            this.nameW = tableWidth * 0.12;
            this.sexW = tableWidth * 0.12;
            this.birthW = tableWidth * 0.13;
            this.useridW = tableWidth * 0.12;
            this.phoneW = tableWidth * 0.14;
            this.openW = tableWidth * 0.12;
        },

        confirmDialog() {
            this.alertShow = false;
        },
        closeDialog(){
            this.alertShow=false;
            //把绑定的弹窗数组 设为false即可关闭弹窗
        },
        getDate(){
            let data = {
                page:this.totalPage,
                pagesize:10
            }
            getComment(data).then( res => {
                if(res.code == 200){
					
                    if(res.data != ''){
						let data = JSON.parse(window.atob(res.data))
                        this.pageCount = Number(data.pager.count);
                        this.tableData = data.data
                    }else{
                        this.alertShow = true;
                        this.tipStatus = "查詢結果";
                        this.tipText = "暫無數據";
                    }
                }else {
                    this.alertShow = true;
                    this.tipStatus = "查詢失敗";
                    this.tipText = res.msg;
                }
            })
        },

        onCurrentChange(val){
            this.totalPage = val;
            this.getDate();
        }
    }
}
